module.exports = __webpack_public_path__ + "static/media/bootstrap.e7014ef8.jpg";